module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('el-main', [_c('div', {
    staticClass: "page-home"
  }, [_c('div', {
    staticClass: "page-home-container"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_c('img', {
    attrs: {
      "width": "200px",
      "height": "200px",
      "src": require("../../image/saturn.png")
    }
  })]), _vm._v(" "), _c('div', [_c('el-autocomplete', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "fetch-suggestions": _vm.querySearchAsync,
      "placeholder": "请输入域名"
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.domainName),
      callback: function($$v) {
        _vm.domainName = $$v
      },
      expression: "domainName"
    }
  }, [_c('i', {
    staticClass: "el-icon-search el-input__icon",
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  })])], 1)]), _vm._v(" "), (_vm.recentVisitDomains) ? _c('form', {
    staticClass: "recent-visit-form"
  }, [_c('fieldset', {
    staticClass: "quick-access"
  }, [_c('legend', {
    staticClass: "quick-access-title"
  }, [_vm._v("--- 快捷访问 ---")]), _vm._v(" "), _c('div', {
    staticClass: "tag-content"
  }, _vm._l((_vm.recentVisitDomains), function(item, key) {
    return _c('span', {
      key: key,
      staticClass: "status-tag",
      on: {
        "click": function($event) {
          _vm.toJobListPage(item.params.domain)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(item.params.domain) + "\n                        ")])
  }))])]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d67dc24a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/job_manage/job_manage.vue
// module id = 1441
// module chunks = 1